import { Theme } from '@material-ui/core/styles';
import TimeOffIcon from '@material-ui/icons/AccessTime';
import DescriptionIcon from '@material-ui/icons/Description';
import PersonIcon from '@material-ui/icons/Person';
import ResponseIcon from '@material-ui/icons/PhoneInTalk';
import SearchIcon from '@material-ui/icons/Search';
import React from 'react';
import { Observe } from 'rewire-core';
import { WithStyle } from 'rewire-ui';
import InfoPanelContent from '../ui/InfoPanelContent';
import InfoPanelFooter from '../ui/InfoPanelFooter';
import InfoPanelHeader from '../ui/InfoPanelHeader';
import Loader from '../ui/Loader';
import { IViewTab } from '../ui/ViewTabs';
import { capitalize } from '../utility/StringUtils';
import AddCommentDialog from './AddCommentDialog';
import commentDialogModel from './CommentDialogModel';
import DuplicateMultipleShiftDialog from './DuplicateMultipleShiftsDialog';
import InfoPanelShiftDetailsView from './InfoPanelShiftDetailsView';
import InfoPanelShiftEmployeesView from './InfoPanelShiftEmployeesView';
import InfoPanelShiftResponseLogView from './InfoPanelShiftResponseLogView';
import InfoPanelShiftSchedulingView from './InfoPanelShiftSchedulingView';
import InfoPanelShiftTimeOffRequestView from './InfoPanelShiftTimeOffRequestView';
import infoPanelShiftViewModel, { IShiftViewType } from './InfoPanelShiftViewModel';
import scheduleModel from './ScheduleModel';
import { withStyles } from '../utility/styles';
// import DuplicateMultipleShiftsDialogModel from './DuplicateMultipleShiftsDialogModel';

const styles = (_theme: Theme) => ({});

interface IInfoPanelShiftViewProps {
  classes?: any;
}

type InfoPanelShiftViewProps = WithStyle<ReturnType<typeof styles>, IInfoPanelShiftViewProps>;

class InfoPanelShiftView extends React.Component<InfoPanelShiftViewProps> {
  viewTabs: IViewTab[];

  constructor(props: InfoPanelShiftViewProps) {
    super(props);

    this.viewTabs = [
      {
        title: 'Details',
        disabled: () => infoPanelShiftViewModel.isView('details'),
        onClick: this.handleCardViewClick('details'),
        content: <DescriptionIcon />,
      },
      {
        title: 'Employees',
        disabled: () => infoPanelShiftViewModel.isView('employees'),
        visible: () => !scheduleModel.isMultiSelect,
        onClick: this.handleCardViewClick('employees'),
        content: <PersonIcon />,
      },
      {
        title: 'Time Off',
        disabled: () => infoPanelShiftViewModel.isView('timeOff'),
        visible: () => !scheduleModel.isMultiSelect,
        onClick: this.handleCardViewClick('timeOff'),
        content: <TimeOffIcon />,
      },
      {
        title: 'Scheduling',
        disabled: () => infoPanelShiftViewModel.isView('scheduling'),
        visible: () => scheduleModel.viewMode === 'Job' && !scheduleModel.isMultiSelect,
        onClick: this.handleCardViewClick('scheduling'),
        content: <SearchIcon />,
      },
      {
        title: 'Response Log',
        disabled: () => infoPanelShiftViewModel.isView('response log'),
        onClick: this.handleCardViewClick('response log'),
        content: <ResponseIcon />,
        visible: () => scheduleModel.viewMode === 'Job' && !scheduleModel.isMultiSelect,
      },
    ];
  }

  componentWillUnmount() {
    infoPanelShiftViewModel.reset();
  }

  handleCardViewClick = (view: IShiftViewType) => () => {
    infoPanelShiftViewModel.setView(view);
  };

  render() {
    return (
      <Observe
        render={() => {
          const hasJob = !!infoPanelShiftViewModel.jobId;
          const isNew = infoPanelShiftViewModel.isNew;
          const isOutsideJobEffectiveRange =
            scheduleModel.viewMode === 'Job' && infoPanelShiftViewModel.isOutsideJobEffectiveRange();
          const viewOnly = infoPanelShiftViewModel.viewOnly;
          const capitalizedView = capitalize(infoPanelShiftViewModel.view);
          let headerTitle = '';
          if (
            scheduleModel.isMultiSelect &&
            infoPanelShiftViewModel.isView('details') &&
            infoPanelShiftViewModel.state.isMultiShiftSelection
          ) {
            headerTitle = 'Shift Details - Apply to All Selected Shifts';
          } else {
            headerTitle = !hasJob
              ? 'No shift for unsaved job'
              : isOutsideJobEffectiveRange
                ? 'Outside job effective range'
                : isNew
                  ? 'No shift for this date'
                  : `Shift ${capitalizedView}`;
          }
          const headerTabs = !hasJob || isOutsideJobEffectiveRange || isNew ? undefined : this.viewTabs;
          const headerOptionsTitle =
            !hasJob || isOutsideJobEffectiveRange ? '' : isNew ? 'Shift Options' : `Shift ${capitalizedView} Options`;
          const headerOptionsItems =
            !hasJob || isOutsideJobEffectiveRange ? undefined : infoPanelShiftViewModel.optionsActionMenuItems;

          return (
            <>
              <InfoPanelHeader
                title={headerTitle}
                tabs={headerTabs}
                optionsMenuTitle={headerOptionsTitle}
                optionsMenuTooltip={headerOptionsTitle}
                optionsItems={headerOptionsItems}
              />
              <Loader loading={infoPanelShiftViewModel.isLoading}>
                <InfoPanelContent>
                  <Observe
                    render={() =>
                      !hasJob || isOutsideJobEffectiveRange || (viewOnly && isNew) ? null : infoPanelShiftViewModel.isView(
                          'details',
                        ) || isNew ? (
                        <InfoPanelShiftDetailsView />
                      ) : infoPanelShiftViewModel.isView('employees') ? (
                        <InfoPanelShiftEmployeesView />
                      ) : infoPanelShiftViewModel.isView('scheduling') ? (
                        <InfoPanelShiftSchedulingView />
                      ) : infoPanelShiftViewModel.isView('response log') ? (
                        <InfoPanelShiftResponseLogView />
                      ) : (
                        <InfoPanelShiftTimeOffRequestView />
                      )
                    }
                  />
                  <DuplicateMultipleShiftDialog />
                  <AddCommentDialog model={commentDialogModel} />
                </InfoPanelContent>
              </Loader>
              {infoPanelShiftViewModel.actions && hasJob && !isOutsideJobEffectiveRange && !(viewOnly && isNew) && (
                <Observe
                  render={() => (
                    <InfoPanelFooter isDisabled={infoPanelShiftViewModel.isDisabled} actions={infoPanelShiftViewModel.actions} />
                  )}
                />
              )}
            </>
          );
        }}
      />
    );
  }
}

export default withStyles<IInfoPanelShiftViewProps>(styles, InfoPanelShiftView);
